import { NordTheme } from "../.internal/themes/NordTheme";
export default NordTheme;
